import { getRouteApi } from '@tanstack/react-router'
import { ButtonGroup, CheckBox, FF, IconName, Link } from 'ui/components'
import { Button, IconButton } from 'ui/components/Buttons'
import { Footer as F } from 'ui/temp/Footer'
import { useDeleteAnnualReviewConfirmation } from '~bank-annual-review/hooks'

import { useAnnualReviewFormContext } from '../../context/ManageAnnualReviewContext'

const routeApi = getRouteApi('/_app/annual-review/edit/$companyId/$id')

export const Footer = () => {
  const { formApi } = useAnnualReviewFormContext()

  const navigate = routeApi.useNavigate()
  const { companyId, id } = routeApi.useParams()

  const { openDeleteAnnualReviewConfirmation, DeleteConfirmation } = useDeleteAnnualReviewConfirmation({
    onSuccess: () =>
      navigate({
        to: '/relationships/$id',
        params: { id: companyId }
      })
  })

  return (
    <>
      <DeleteConfirmation />
      <F>
        <formApi.Subscribe
          children={() => (
            <>
              <formApi.Field
                name="isCompleted"
                children={(isCompletedField) => (
                  <FF
                    field={isCompletedField}
                    input={(inputProps) => (
                      <CheckBox checkBoxLabel="Is Review Completed?" data-qa="Is Review Completed?" {...inputProps} />
                    )}
                  />
                )}
              />
              <IconButton
                face="negative"
                icon={IconName.DELETE}
                onClick={() => openDeleteAnnualReviewConfirmation(Number(id))}
              >
                Delete
              </IconButton>
              <ButtonGroup margin="small">
                <Link to="/annual-review/detail/$companyId/$id" params={{ companyId, id }}>
                  <Button face="secondary">Cancel</Button>
                </Link>
                <Button face="primary" onClick={formApi.handleSubmit}>
                  Submit
                </Button>
              </ButtonGroup>
            </>
          )}
        />
      </F>
    </>
  )
}
